export const BASE_URL =
  // "https://testing-sirenlaravel.ninositsolution.com/public/crm/"; // testing
  // "http://192.168.1.52/singapore-siren/public/crm/";
  // "https://testing.knfepl.com/public/crm/"; // UAT
  // "https://sirenlaravel-phase3.ninositsolution.com/public/crm/"; // phase 3 testing
  //"https://testing.knfepl.com/public/crm/"; // phase 3 live
  "https://uat.testing.ninositsolution.com/public/crm/"; //UAT TESTing

export const URL = {
  //AUTHENTICATION
  LOGIN: "admin-login",
  LOGOUT: "admin-logout",
  COMPANY_LOGOUT: "subadmin-logout",
  FORGOT_PASSWORD: "admin/forgot-password",
  TOKEN_VERIFY: "admin-token-verify/",
  CHANGE_PASSWORD: "admin-set-password",

  //ADMIN

  ADD_ADMIN: "add-admin",
  VIEW_ADMIN: "view-admin/",
  ADMIN_STATUS: "change-admin-status/",
  UPDATE_ADMIN: "update-admin",
  LIST_ADMIN: "admin-lists",
  DELETE_ADMIN: "delete-admin/",

  //ROLE

  PERMISSIONS_LIST: "admin/role/module-lists",
  SUBADMIN_PERMISSIONS_LIST: "subadmin/role/module-lists",
  ROLE_LIST: "admin/role/lists",
  ADD_ROLE: "add-role",
  UPDATE_ROLE: "update-role",
  DELETE_ROLE: "delete-role/",
  VIEW_ROLE: "view-role/",
  ROLE_STATUS: "change-role-status/",

  // Company
  COMPANY_LIST: "company-list",
  COMPANY_ADD: "add-company",
  COMPANY_EDIT: "update-company/",
  COMPANY_STATUS: "change-company-status/",
  COMPANY_DELETE: "company-delete/",
  COMPANY_ROLE_LIST: "role-list",
  COMPANY_List_VIEW: "company/view/",
  ADMIN_COMPANY_VIEW: "company/",

  // company Devices
  COMPANY_DEVICES: "company/devices",
  COMPANY_DEVICES_VIEW: "device/view/",
  COMPANY_DEVICES_EDIT: "device/update/",
  COMPANY_DEVICES_STATUS: "change-companydevice-status/",
  // company Manager
  COMPANY_MANAGER: "company/profile",
  COMPANY_MANAGER_EDIT: "company/profile/update",
  COMPANY_LOCATION: "location-list",
  // Profile subadmin
  SUBADMIN_LIST: "subadmin-lists",
  SUBADMIN_ADD: "add-subadmin",
  SUBADMIN_VIEW: "view-subadmin/",
  SUBADMIN_EDIT: "subadmin/update/",
  SUBADMIN_STATUS: "change-subadmin-status/",
  SUBADMIN_ROLES: "subadmin-role-list",
  SUBADMIN_ROLES_VIEW: "subadmin-view-role/",
  // profile users
  PROFILE_USER_LIST: "users-lists",
  CHECK_MEMBERS: "check-user-email",
  MEMBERS_LIST: "/device/",
  MEMBERS_LIST_ADD: "add-new/user/",

  // USER LIST
  USER_LIST: "user-lists",
  ADD_USER: "add-user",
  UPDATE_USER: "update-user",
  VIEW_USER: "view-user/",
  USER_STATUS: "change-user-status/",

  // DEVICE LIST
  DEVICE_LIST: "device-lists",
  DEVICE_ADD: "add-device",
  DEVICE_VIEW: "view-device/",
  DEVICE_UPDATE: "update-device",
  DEVICE_STATUS: "change-device-status/",
  DEVICE_USER_LIST: "device-user-lists",
  DEVICE_REPORT: "get-device-logs",
  SUBADMIN_DEVICE_REPORT: "subadmin-get-device-logs",
  DEVICE_REPORT_EXPORT: "export-device-logs",
  NOTIFICATION_REPORT: "get-device-notification-logs",
  SUBADMIN_NOTIFICATION_REPORT: "subadmin-get-device-notification-logs",
  NOTIFICATION_REPORT_EXPORT: "export-device-notification-logs",

  //LOCATION
  LOCATION_LIST: "location-lists",
  LOCATION_STATUS: "change-location-status/",

  // MANUAL_TRIGGER
  MANUAL_TRIGGER: "mannualy-publish-mqtt/",
  CALCULATE_DISTANCE: "calculate-distance",

  // LOG FILE
  LOG_FILE: "logs",
};

export const TOKEN = "token";
export const LOGGEDUSER = "loggeduser";
export const USER_DETAILS = "user_details";
export const PROFILE = "profile";
export const LOCATION = "userlocation";
export const LOCATIONNAME = "locationname";

export const NUMBER = /^\+?(0|[6-9]\d*)$/;

export const EMAIL =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PASS =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*.?&])[A-Za-z\d@$!%.*?&]{8,}$/;
export const isValidEmail = (email) => {
  return EMAIL.test(email);
};

export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const productDetailImg = {
  loop: true,
  autoplay: false,
  center: true,
  dots: true,
  autoplayTimeout: 3000,
  smartSpeed: 450,
  nav: false,
  responsive: {
    0: {
      items: 1,
    },
  },
};

//Refer at https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_expressions
export const formatKey = (key) => {
  return key
    .replace(/_/g, " ") // underscores to spaces
    .replace(/([a-z])([A-Z])/g, "$1 $2") // camelCase too split
    .replace(/\s+/g, " ") // simple spaces
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase()); // capital words
};

export const validatePassword = (pass) => {
  if (!pass) return "Enter password";
  if (!/[A-Z]/.test(pass)) return "Password must contain uppercase letters";
  if (!/[a-z]/.test(pass)) return "Password must contain lowercase letters";
  if (!/[0-9]/.test(pass)) return "Password must contain numbers";
  if (pass.length < 8) return "Password must be at least 8 characters";
  if (!/[!*@#%&()^~{}]/.test(pass))
    return "Password must contain a special character";
  return "";
};

export const validateConfirmPassword = (pass, confirmPass) => {
  if (!confirmPass) return "Enter confirm password";
  if (confirmPass !== pass) return "Passwords do not match";

  // Also check same password rules
  return validatePassword(confirmPass);
};
